import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/checklists/$slug")({
  head: () => buildRouteHead("/en/checklists", { noIndex: true }),
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/en/downloads/checklists/$slug",
      params: { slug: params.slug },
      replace: true,
    });
  },
});
